import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { AdminUserCriteria } from "./schema";

export async function getAdminUsers(api: ApiClient, criteria: AdminUserCriteria, signal?: AbortSignal) {
  return (await api.get<Schemas["AdminUserPageResponse"]>("/api/v1/admin/admin-users", {
    query: {
      status: criteria.status || undefined,
      roleCode: criteria.roleCode || undefined,
      page: criteria.page,
      size: criteria.size,
    },
    signal,
    cache: "no-store",
  })).data;
}

export async function createAdminUser(api: ApiClient, body: Schemas["CreateAdminRequest"], signal?: AbortSignal) {
  return (await api.post<Schemas["AdminUserResponse"], Schemas["CreateAdminRequest"]>("/api/v1/admin/admin-users", body, { signal, cache: "no-store" })).data;
}

export async function changeAdminRoles(api: ApiClient, adminUserId: number, body: Schemas["ChangeAdminRolesRequest"], signal?: AbortSignal) {
  return (await api.put<Schemas["AdminUserResponse"], Schemas["ChangeAdminRolesRequest"]>(`/api/v1/admin/admin-users/${adminUserId}/roles`, body, { signal, cache: "no-store" })).data;
}

export async function disableAdminUser(api: ApiClient, adminUserId: number, body: Schemas["DisableAdminRequest"], signal?: AbortSignal) {
  await api.post<void, Schemas["DisableAdminRequest"]>(`/api/v1/admin/admin-users/${adminUserId}/disable`, body, { signal, cache: "no-store" });
}

export async function resetAdminTotp(api: ApiClient, adminUserId: number, body: Schemas["ResetAdminTotpRequest"], signal?: AbortSignal) {
  await api.post<void, Schemas["ResetAdminTotpRequest"]>(`/api/v1/admin/admin-users/${adminUserId}/totp/reset`, body, { signal, cache: "no-store" });
}
